import api from "@/lib/api";
import type { CreateCusTransaction } from "@validation/customer";

export const getPaymentStatus = async (idempotencyKey: string) => {
  const { data } = await api.get<{ status: "PAID" | "UNPAID" | "UNKNOWN" }>(
    "/payment/check-payment-status",
    {
      params: {
        idempotencyKey,
      },
    },
  );
  return data;
};

export const requestPayment = async <T>(body: CreateCusTransaction) => {
  const { data } = await api.post<T>("/payment/req-pay", body);
  return data;
};

export const requestRefund = async <T>(body: CreateCusTransaction) => {
  const { data } = await api.post<T>("/payment/req-refund", body);
  return data;
};
